import React from 'react'
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";

const mapping = {
        0: "Awake",
        1: "N1",
        2: "N2",
        3: "N3",
        4: "Light N2",
        5: "REM",
        6: "Error"
    };

class Thing extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }
    render() {
        const {
            common,
            leastCommon, 
            averages} = this.props;
        console.log(common)
        return (
            <Row>
                <Col lg="4" md="6" sm="6">
                    <Card className="card-stats">
                        <CardBody>
                            <Row>
                                <Col md="4" xs="5">
                                    <div className="icon-big text-center icon-warning">
                                        <i className="fas fa-bed text-success" />
                                    </div>
                                </Col>
                                <Col md="8" xs="7">
                                    <div className="numbers">
                                        <p className="card-category">Most Common Stage</p>
                                        <CardTitle tag="p">{common[0]}</CardTitle>
                                        <p />
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                        <CardFooter>
                            <hr />
                            <div className="stats">
                                <i className="fas fa-sync-alt" /> {(common[1]*100).toFixed(2)}% during sleep cycle
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
                <Col lg="4" md="6" sm="6">
                    <Card className="card-stats">
                        <CardBody>
                            <Row>
                                <Col md="4" xs="5">
                                    <div className="icon-big text-center icon-warning">
                                        <i className="fas fa-clock text-warning" />
                                    </div>
                                </Col>
                                <Col md="8" xs="7">
                                    <div className="numbers">
                                        <p className="card-category">Least Common Stage</p>
                                        <CardTitle tag="p">{leastCommon[0]}</CardTitle>
                                        <p />
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                        <CardFooter>
                            <hr />
                            <div className="stats">
                                <i className="far fa-calendar" /> {(leastCommon[1]*100).toFixed(2)}% during sleep cycle
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
                {/* 
                <Col lg="4" md="6" sm="6">
                    <Card className="card-stats">
                        <CardBody>
                            <Row>
                                <Col md="4" xs="5">
                                    <div className="icon-big text-center icon-warning">
                                        <i className="nc-icon nc-vector text-danger" />
                                    </div>
                                </Col>
                                <Col md="8" xs="7">
                                    <div className="numbers">
                                        <p className="card-category">Errors</p>
                                        <CardTitle tag="p">23</CardTitle>
                                        <p />
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                        <CardFooter>
                            <hr />
                            <div className="stats">
                                <i className="far fa-clock" /> In the last hour
                            </div>
                        </CardFooter>
                    </Card>
                </Col>
                
                <Col lg="4" md="6" sm="6">
                    <Card className="card-stats">
                        <CardBody>
                            <Row>
                                <Col md="4" xs="5">
                                    <div className="icon-big text-center icon-warning">
                                        <i className="nc-icon nc-favourite-28 text-primary" />
                                    </div>
                                </Col>
                                <Col md="8" xs="7">
                                    <div className="numbers">
                                        <p className="card-category">Followers</p>
                                        <CardTitle tag="p">+45K</CardTitle>
                                        <p />
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                        <CardFooter>
                            <hr />
                            <div className="stats">
                                <i className="fas fa-sync-alt" /> Update now
                </div>
                        </CardFooter>
                    </Card>
                </Col>
                */}
            </Row>
        )
    }
}
export default Thing;